export default "__VITE_ASSET__20ec935a__"